import React, { useState, useEffect } from 'react';

const TypewriterButton = ({ text = "Click Me!", color = "#6366f1", onClick }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const typingSpeed = isDeleting ? 50 : 100;
    const pauseTime = 2000;

    const timer = setTimeout(() => {
      if (!isDeleting && currentIndex < text.length) {
        setDisplayText(text.substring(0, currentIndex + 1));
        setCurrentIndex(currentIndex + 1);
      } else if (!isDeleting && currentIndex === text.length) {
        setTimeout(() => setIsDeleting(true), pauseTime);
      } else if (isDeleting && currentIndex > 0) {
        setDisplayText(text.substring(0, currentIndex - 1));
        setCurrentIndex(currentIndex - 1);
      } else if (isDeleting && currentIndex === 0) {
        setIsDeleting(false);
      }
    }, typingSpeed);

    return () => clearTimeout(timer);
  }, [currentIndex, isDeleting, text]);

  const buttonStyle = {
    backgroundColor: color,
    color: '#3d52a0',
    padding: '4px 8px',
    fontSize: '15px',
    fontWeight: 'bold',
    border: '1px solid #3d52a0',
    borderRadius: '8px',
    cursor: 'pointer',
    minWidth: '240px',
    height: '34px',
    boxShadow: `0 10px 40px ${color}66`,
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden'
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // minHeight: '100vh',
    // background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
    // gap: '32px',
    // flexDirection: 'column'
  };

  const cursorStyle = {
    animation: 'blink 1s infinite'
  };

  return (
    <div style={containerStyle}>
      <style>{`
        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0; }
        }
        button:hover {
          transform: scale(1.05);
          box-shadow: 0 15px 50px ${color}88;
        }
        button:active {
          transform: scale(0.95);
        }
      `}</style>
      
      <button style={buttonStyle} onClick={onClick}>
        <span>
          {displayText}
          <span style={cursorStyle}>|</span>
        </span>
      </button>
    </div>
  );
};

export default TypewriterButton;